import api from "./api";

const certificateService = {
  get: (jwttoken) =>
    api.get(`/certificates`, {
      headers: { 'Authorization': `Basic ${jwttoken}` }
    }),
};
export default certificateService;